import { TimeFlag as a } from "../../types.js";
import { struct as c, withFreezeProxyHandlers as l } from "../../../../../../utils/struct/main.js";
import { isString as o } from "../../../../../../utils/value/is.js";
const m = (() => {
  const r = {}, s = Object.keys(a).filter((e) => isNaN(+e)), i = (e) => e !== "ALL" && o(e) && s.includes(e);
  return (e) => {
    const t = e & a.ALL;
    return r[t] || (r[t] = new Proxy(
      c({
        valueOf: { value: () => t }
      }),
      l({
        get: (u, n) => {
          switch (n) {
            case "valueOf":
              return u.valueOf;
            case Symbol.toStringTag:
              return "_";
            default:
              if (!i(n)) return;
          }
          return t & a[n] ? 1 : void 0;
        }
      })
    )), r[t];
  };
})();
export {
  m as default
};
